
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch} from 'vue-property-decorator';
import DefaultFooter from '@/layouts/page/Footer.vue';

// Models
import { MenuItem, Menu } from '@/models/Menu.model';

// 3rd Party
import colors from 'vuetify/lib/util/colors';

@Component({
  components: {
    DefaultFooter,
  },
})
export default class Dashboard extends Vue {
  @Prop(String) readonly backgroundColor!: string;
  @Prop(String) readonly textColor!: string;
  @Prop(String) readonly hoverColor!: string;
  @Prop(String) readonly hoverTextColor!: string;
  @Prop(String) readonly activeColor!: string;
  @Prop(String) readonly activeTextColor!: string;
  @Prop(String) readonly drawer!: string;
  @Prop(String) readonly drawerLogo!: string;
  @Prop(String) readonly drawerLogoMobile!: string;
  @Prop({default: 'openSideMenu'}) readonly openSideMenuIcon!: string;
  @Prop({default: 'closeSideMenu'}) readonly closeSideMenuIcon!: string;
  @Prop({default: 'openSideMenuMobile'}) readonly openSideMenuIconMobile!: string;
  @Prop({default: 'closeSideMenuMobile'}) readonly closeSideMenuIconMobile!: string;
  @Prop(String) readonly title!: string;
  @Prop(Boolean) readonly allowToggle!: boolean;
  @Prop(Boolean) readonly defaultOpen!: boolean;
  @Prop(Object) readonly sideMenuConfig!: Menu;
  @Prop(Object) readonly topMenuConfig!: Menu;
  @Prop(Boolean) readonly mobileOnly!: boolean;

  isMounted: boolean = false;
  sideMenuItems: Menu = {theme: {}};
  topMenuItems: Menu = {theme: {}};

  debounceTimeout: number = 0;

  $refs!: {
    dashboardContainer: HTMLDivElement,
  };

  @Watch('mobileOnly')
  onMobileOnlyChanged() {
    this.isMounted = false;
    this.calculateMenus();
    this.isMounted = true;
  }

  mounted() {
    this.calculateMenus();    
    this.isMounted = true;
  }
  
  calculateMenus() {
    const activeSideMenuItems = this.sideMenuConfig.items;
    const activeTopMenuItems = this.topMenuConfig.items;

    if (this.mobileOnly) {
      this.sideMenuItems = {
        items:  [... new Set(
          [
            ...(activeTopMenuItems as MenuItem[]).filter((item: MenuItem) => item.priority),
            ...(activeSideMenuItems  as MenuItem[]).filter((item: MenuItem) => item),
            ...(activeTopMenuItems  as MenuItem[]).filter((item: MenuItem) => !item.priority),
          ],
          )],
          theme: this.sideMenuConfig.theme,
        };
      this.topMenuItems.items = undefined;
      return;
    }

    if (!this.$vuetify.breakpoint.lgAndUp) {
      this.sideMenuItems = {
        items:  [... new Set(
          [
            ...(activeTopMenuItems as MenuItem[]).filter((item: MenuItem) => item.priority),
            ...(activeSideMenuItems  as MenuItem[]).filter((item: MenuItem) => item),
            ...(activeTopMenuItems  as MenuItem[]).filter((item: MenuItem) => !item.priority),
          ],
          )],
          theme: this.sideMenuConfig.theme,
        };
      this.topMenuItems.items = undefined;
    }
  
    
    if (this.$vuetify.breakpoint.lgAndUp) {
      this.sideMenuItems = { items: activeSideMenuItems as MenuItem[], theme: this.sideMenuConfig.theme}; // can be overwritten
      this.topMenuItems = { items: activeTopMenuItems as MenuItem[], theme: this.topMenuConfig.theme}; // can be overwritten
    }
  }

  dashboardResized() {
    this.$nextTick(() => {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
      }

      this.debounceTimeout = setTimeout(() => {
        this.calculateMenus();
      }, 500);
    }); 
  }

  getHeaderBackgroundColor() {
    if (this.topMenuConfig && this.topMenuConfig.theme) {
      if (this.topMenuConfig.theme.backgroundColor) {
        return {'--headerBackgroundColor': this.getColor(this.topMenuConfig.theme.backgroundColor)};
      }
    }

    return {'--headerBackgroundColor': '#fff'};
  }

  getColor(colorString: string) {
    if (colorString.indexOf('#') > -1) {
      return colorString;
    }

    if (this.$vuetify.theme.currentTheme) {
      for (const [colorIndex, color] of Object.entries(this.$vuetify.theme.currentTheme)) {
        if (colorString === colorIndex) {
          return color + '';
        }
      }
    }

    if (colors) {
      for (const [colorIndex, color] of Object.entries(colors)) {
        if (colorString === colorIndex) {
          return color.base + '';
        }
      }
    }

    return colorString;
  }
}
